module.exports = __webpack_public_path__ + "static/img/banner-icon.2d54ead4.svg";